import apiClient from "./api";

export interface Skill {
  id: string;
  name: string;
  category?: string;
  humanReadableDescription: string;
  triggerContext: string;
  skillPrompt: string;
  isActive: boolean;
}

export interface WidgetSkill {
  id: string;
  widgetId: string;
  skillId: string;
  order: number;
  enabled: boolean;
  skill: Skill;
}

export interface WizardMessage {
  role: "user" | "assistant";
  content: string;
}

export interface SkillCompilerResult {
  humanReadableDescription: string;
  triggerContext: string;
  skillPrompt: string;
  name?: string;
  category?: string;
}

export interface SkillCompileRequest {
  conversation?: WizardMessage[];
  currentDescription?: string;
  changeRequest?: string;
}

export interface CreateSkillRequest {
  name: string;
  category?: string;
  humanReadableDescription: string;
  triggerContext: string;
  skillPrompt: string;
}

export interface UpdateSkillRequest {
  name?: string;
  category?: string;
  humanReadableDescription?: string;
  triggerContext?: string;
  skillPrompt?: string;
  isActive?: boolean;
}

export const skillService = {
  wizardMessage: (
    conversation: WizardMessage[],
  ): Promise<{ message: string }> =>
    apiClient
      .post("/skills/wizard/message", { conversation })
      .then((r) => r.data),

  compileSkill: (request: SkillCompileRequest): Promise<SkillCompilerResult> =>
    apiClient.post("/skills/compile", request).then((r) => r.data),

  getSkills: (): Promise<Skill[]> =>
    apiClient.get("/skills").then((r) => r.data),

  getSkill: (skillId: string): Promise<Skill> =>
    apiClient.get(`/skills/${skillId}`).then((r) => r.data),

  createSkill: (data: CreateSkillRequest): Promise<Skill> =>
    apiClient.post("/skills", data).then((r) => r.data),

  updateSkill: (skillId: string, data: UpdateSkillRequest): Promise<Skill> =>
    apiClient.put(`/skills/${skillId}`, data).then((r) => r.data),

  deleteSkill: (skillId: string): Promise<void> =>
    apiClient.delete(`/skills/${skillId}`).then((r) => r.data),

  getWidgetSkills: (widgetId: string): Promise<WidgetSkill[]> =>
    apiClient.get(`/widget/${widgetId}/skills`).then((r) => r.data),

  assignSkill: (widgetId: string, skillId: string): Promise<WidgetSkill> =>
    apiClient
      .post(`/widget/${widgetId}/skills`, { skillId })
      .then((r) => r.data),

  removeSkill: (widgetId: string, skillId: string): Promise<void> =>
    apiClient
      .delete(`/widget/${widgetId}/skills/${skillId}`)
      .then((r) => r.data),

  reorderSkills: (widgetId: string, orderedSkillIds: string[]): Promise<void> =>
    apiClient
      .put(`/widget/${widgetId}/skills/reorder`, { orderedSkillIds })
      .then((r) => r.data),
};
